import _ from 'lodash';

const getPaginatePageItems = (data, itemsPerPage) => {
    const paginatedItems = _.chunk(data, itemsPerPage);
    return paginatedItems;
}
export default getPaginatePageItems;
